import axios from '../plugins/axios'

// XAN-193 — proyectos del gestor de tickets internos (XAN-24).

export const createProject = (project) => axios.post('/project', project)

export const getProjects = (params) => axios.get('/project', { params })

export const getProject = (id) => axios.get(`/project/${id}`)

export const updateProject = (id, project) => axios.put(`/project/${id}`, project)

export const deleteProject = (id) => axios.delete(`/project/${id}`)

export const addProjectMember = (id, userId) => axios.post(`/project/${id}/members`, { userId })

export const removeProjectMember = (id, memberId) => axios.delete(`/project/${id}/members/${memberId}`)

// XAN-193 (adjustments) — module-level universe: every user assignable to any project (the six
// allowed roles, Analista excluded). ADMIN only, since it feeds the member picker on the
// "Proyectos" screen.
export const getAssignableUsers = () => axios.get('/project/assignable-users')

// Project-level universe: only the users an ADMIN assigned to THAT project. This is the single
// valid source for any user picker shown inside a project (assigning a ticket, and whatever is
// added later) — never the full risk_shield roster.
export const getProjectMembers = (id) => axios.get(`/project/${id}/members`)
